// @flow
import { KEY } from './constants'

export const SET_ACCOUNTS = `${KEY}/SET_ACCOUNTS`
export const SET_CONTACTS = `${KEY}/SET_CONTACTS`
export const SET_SSN_VERIFIER = `${KEY}/SET_SSN_VERIFIER`
